import { Box, Typography } from '@mui/material';
import { DisplayInfo } from 'api/ordering-service/ordering-service.types';
import { useTranslation } from 'react-i18next';
import MenusDisplayContentTabs from './menus-display-content-tabs/menus-display-content-tabs.component';

type MenusDisplayContentProps = {
  displayInfos: DisplayInfo[];
};

const MenusDisplayContent = ({ displayInfos }: MenusDisplayContentProps) => {
  const { t } = useTranslation();

  return (
    <Box data-testid="MenusDisplayContent" mt={2}>
      <Typography variant="h2">
        {t('drawer.menusDetailsDrawer.displayContent.heading')}
      </Typography>
      <MenusDisplayContentTabs displayInfos={displayInfos} />
    </Box>
  );
};

export default MenusDisplayContent;
